// test890
(890 && 0);
